import { action, makeAutoObservable, observable } from 'mobx';
import { showError } from '@/utils/common';
import { api } from '@/api';

export class DashboardGlobalStore {
  @observable data: cyrian.api.dashboardGlobal.Data | null = null;
  @observable loading: boolean = false;
  private lastParams: cyrian.api.dashboardGlobal.GetParams | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  private setData(data: cyrian.api.dashboardGlobal.Data | null) {
    this.data = data;
  }

  @action
  private setLoading(loading: boolean) {
    this.loading = loading;
  }

  async fetchData(params?: cyrian.api.dashboardGlobal.GetParams) {
    this.lastParams = params;
    this.setLoading(true);
    try {
      const { data: response } = await api.dashboardGlobal.getData(params).source;
      this.setData(response);
    } catch (error) {
      showError(error);
      this.setData(null);
    } finally {
      this.setLoading(false);
    }
  }

  /** Re-fetch using last GET params (e.g. after error). */
  async refreshData() {
    await this.fetchData(this.lastParams);
  }
}
